<template>
<div>
  <div class="centered-column">
    <div class="container-header">
      <h3>{{ label.get('archived_members') }} ({{ totalMembersCount }})</h3>

      <datepicker-component
          @onDateSelected="onDateSelected"
      />
    </div>

    <timesheet-overview-component :overview="overview"/>

    <div class="d-flex">
      <div class="col col-md-6 pl-0 pr-2">
        <timesheet-payroll-component :payroll="payroll" />
      </div>
      <div class="col col-md-6 pr-0 pl-2">
        <timesheet-job-codes-component :job-codes="jobCodes" />
      </div>
    </div>


  </div>
  <div class="centered-column">
    <div class="white-card">
      <div class="white-card-header">
        <div class="title-wrap">
          <label class="title-label">{{ label.get('timesheets') }}</label>
         <!-- <i class="atto info-icon" id="tooltip-timesheets"></i>
          <b-tooltip
              target="tooltip-timesheets"
              custom-class="info-tooltip"
              placement="bottom" >
            <label>Job Codes</label>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
              dolore magna aliqua. Ut enim ad minim veniam, quis.</p>
          </b-tooltip>-->
        </div>
        <div>
          <timesheet-tools-component
              :member="member"
              :download="true"
          />
        </div>
      </div>
      <div
          class="content-list"
          :class="{'b-loaded': loading}"
      >
        <div
            v-if="loading"
            class="loading-spinner"
        />
        <div
            v-if="!loading"
            class="table-header"
        >
          <!-- <span class="column-header date">&nbsp;</span>-->
          <span class="column-header name">{{ label.get('name') }}</span>
          <span class="second-column">
            <span class="column-header regular">{{ label.get('regular') }}</span>
            <span v-if="isVisibleOvertime" class="column-header overtime">{{ label.get('overtime') }}</span>
            <span v-if="isVisibleDoubleOvertime" class="column-header double_ot">{{ label.get('double_ot')}}</span>
            <span class="column-header unpaid_break">{{ label.get('unpaid_break') }}</span>
            <span class="column-header paid_break">{{ label.get('paid_break') }}</span>
            <span class="column-header time_off">{{ label.get('time_off') }}</span>
            <span class="column-header paid_time_off">{{ label.get('paid_time_off') }}</span>
            <span class="column-header total">{{label.get('total')}}</span>
            <span class="column-header est-pay">{{ label.get('est_pay') }}</span>
          </span>
        </div>
        <div class="table-content">
          <ul class="logs-list hour-total member-list">
            <li
                v-for="(item, idx) in team"
                :key="idx"
            >
              <router-link :to="{ name: 'MemberTimesheets', params: { uid: item.uid }}">
                <div class="first-column">
                  <div
                      class="profile-pic"
                      :class="{'no-avatar': !item.avatar}"
                  >
                    <span
                        v-if="!item.avatar"
                        class="initials"
                    >
                      {{ item.initials }}
                    </span>
                    <img
                        v-if="item.avatar"
                        :src="item.avatar"
                        width="30"
                        height="30"
                    >
                  </div>
                  <div class="name">
                    <h4>{{ item.name }}</h4>
                  </div>
                </div>
                <div class="hour-total">
                  <span class="hours regular">{{ item.regular }}</span>
                  <span v-if="isVisibleOvertime" class="hours overtime">{{ item.overtime }}</span>
                  <span v-if="isVisibleDoubleOvertime" class="hours double_ot">{{item.double_overtime}}</span>
                  <span class="hours unpaid_break">{{item.unpaid_break}}</span>
                  <span class="hours paid_break">{{item.paid_break}}</span>
                  <span class="hours time_off">{{item.unpaid_time_off}}</span>
                  <span class="hours paid_time_off">{{item.paid_time_off}}</span>
                  <span class="hours total_hours">{{item.total_hours}}</span>
                  <span class="hours est-pay">{{item.est_total_pay}}</span>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
    import TimesheetService from "../shared/TimesheetService";
    import DatepickerComponent from "../components/DatepickerComponent";
    import TimesheetToolsComponent from '../components/TimesheetToolsComponent';
    import SelectDropdownComponent from "../../../shared/components/SelectDropdownComponent";
    import TimesheetOverviewComponent from "../shared/components/TimesheetOverviewComponent";
    import TimesheetPayrollComponent from "../shared/components/TimesheetPayrollComponent";
    import TimesheetJobCodesComponent from "../shared/components/TimesheetJobCodesComponent";


    export default {
        name: "ArchivedMembersComponent",
        components: {
            TimesheetToolsComponent,
            DatepickerComponent,
            SelectDropdownComponent,
            TimesheetOverviewComponent,
            TimesheetPayrollComponent,
            TimesheetJobCodesComponent,

        },
        data() {
            return {
                member: null,
                period: '',
                department: '',
                overview: [],
                payroll: null,
                jobCodes: [],
                team: [],
                isLoading: false,
                jobSites : [],
                jobSiteId : '',
                deleted : true,
                totalMembersCount : 0
            }
        },
        computed: {
          loading() {
              return this.isLoading;
          },
          showJobSitesFilter() {
            return this.$store.state.jobSites !== null;
          },
          filteredJobSites() {
            const jobSites =  this.$store.state.jobSites.map(item => {
              return {
                value: item.id,
                label: item.name
              };
            });
            jobSites.unshift({value: '', label: 'All Job Sites'});

            return jobSites;
          },
          isVisibleOvertime() {
            return this.$store.state.companySettings.weekly_overtime || this.$store.state.companySettings.daily_overtime;
          },
          isVisibleDoubleOvertime() {
            return this.$store.state.companySettings.daily_double_overtime;
          }
        },
        mounted() {
          this.getTimesheetData(this.$store.state.period.from, this.$store.state.period.to);
          window.scrollTo(0, 0);
        },
        methods: {
          getTimesheetData: function (from, to, department) {
            let _this = this;
            this.isLoading = true;
            TimesheetService.getTimesheets(from, to, department, _this.jobSiteId, _this.deleted).then((data) => {
              _this.period = data.period;
              _this.overview = data.overview;
              _this.payroll = data.payroll;
              _this.jobCodes = data.job_codes;
              _this.team = data.team;

              _this.totalMembersCount = _this.team.length;
                /*_this.members = data.members.map((item) => {
                  const memberStore = _this.$store.state.archivedMembers.filter((member) => {
                    return member.id === item.id
                  });

                  if (memberStore !== null && memberStore.length > 0) {
                    item.uid = memberStore[0].uid;
                    item.avatar = memberStore[0].avatar;

                  }
                  return item;
                });
              _this.totalMembersCount = _this.members.length;*/
              this.isLoading = false;
            }).catch((error) => {
              this.isLoading = false;
            });
          },


          onDateSelected: function (dateRange) {
            this.clearReportData();
            const from = this.$moment(dateRange.startDate);
            const to = this.$moment(dateRange.endDate);
            this.$store.commit("period", {
              from: from.format('YYYY-MM-DD'),
              to: to.format('YYYY-MM-DD'),
              fromFormatted: from.format('MMM D, YYYY'),
              toFormatted: to.format('MMM D, YYYY')
            });
            this.getTimesheetData(this.$store.state.period.from, this.$store.state.period.to, this.department);
          },

          clearReportData() {
            this.report = {
              total_time: '',
              regular_time: '',
              overtime: '',
              breaks: '',
              pto: '',
              jobs: []
            };
            this.members = [];
          },
          onJobSiteSelected(selected) {
            this.jobSiteId = selected.value;
            this.getTimesheetData(this.$store.state.period.from, this.$store.state.period.to);
          }
        }
    }
</script>
<style lang="scss">
.filter-job-sites{
  .b-dropdown {

    .dropdown-toggle {
      display: inline-flex;
      align-items: center;
      background-color: $atto-white;
      border: 2px solid $atto-light-grey;
      padding: 12px 8px 12px 12px;
      width: 200px;
      height: 48px;
      position: relative;
      margin-left: 16px;
      cursor: pointer;
      border-radius: 0;
      @include base-transition(ease all 0.15s);

      span.filter-title {
        color: $atto-not-active;
        font-family: $roboto-font;
        font-weight: 500;
        font-size: 0.875rem;
        line-height: 1.2rem;
      }

      &:hover {
        text-decoration: none;
        border-color: $grey-nuance-darker;
      }

      &:focus,
      &:active,
      &:active:focus {
        text-decoration: none;
      }
    }

    .dropdown-menu {
      border: 0;
      position: absolute;
      top: -8px;
      left: 0;
      width: 200px;
      box-shadow: 0 0 10px 0 rgba(38, 38, 38, 0.15);
      background-color: $atto-white;
      border-radius: 0;
      padding: 0 0 8px 0;
      margin: -48px 0 0 1px;

      li.disabled {
        a {
          display: flex;
          flex-direction: row;
          padding: 12px 8px 12px 12px;
          align-items: center;
          border-bottom: 2px solid $atto-light-grey;
          margin-bottom: 8px;

          p {
            flex-grow: 1;
            margin-bottom: 0;
            font-size: 0.875rem;
            line-height: 1.5rem;
            font-family: $roboto-font;
            color: $atto-font-color;
            font-weight: 500;
          }

          &:hover {
            background-color: transparent;
          }
        }

      }

      li {
        display: flex;
        padding: 0;

        a {
          padding: 12px 8px 12px 12px;
          font-size: 0.875rem;
          line-height: 1.5rem;
          font-family: $roboto-font;
          color: $atto-font-color;
          font-weight: 500;
          width: 100%;
          cursor: pointer;
          display: flex;
          align-items: center;

          &:hover {
            background-color: #F7F7F7;
          }
        }
      }
    }

    i.atto-u-arrow-b,
    i.atto-d-arrow-b {
      font-size: 12px;
      color: #c9c9c9;
      margin-left: auto;
      margin-right: 8px;
    }

    i.atto-d-arrow-b {
      margin-right: 7px;
    }

  }
}
.gray-timesheet-overlay{
  background-color: rgba(239, 239, 239, 0.4);

  .loading-spinner{
    border-left-color: transparent !important;
  }
}
</style>
<style lang="scss" scoped>
.right-block{
  display: flex;
  flex-flow: row;

  .filter-job-sites{

    .atto-select{
      height: 48px;
      width: 174px;
    }
  }
  .date-picker{
    margin-left: 16px;
  }
}
.white-card{
  /*min-height: 268px;*/
  height: 100%;

  .table-header{
    background-color: #FAFAFA;
    padding: 12px 0 12px 54px;
    height: 35px;
    align-items: center;
    display: flex;
    justify-content: space-between;
    span{
      &.column-header{
        color: #666666;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        font-size: 0.625rem;
        line-height: 0.6875rem;
        width: 85px;
        margin-right: 0;
      }
      &.name{
        width: 350px;
      }
      &.second-column{
        width: 100%;
        display: flex;
        justify-content: space-between;
      }
    }
  }
}

.member-list {
  li {
    .first-column{
      display: flex;
      width: 405px;
    }
    .profile-pic {
      border-radius: 100%;
      width: 30px;
      min-width: 30px;
      max-width: 30px;
      height: 30px;
      margin-right: 8px;

      span.initials {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.875rem;
        /*  line-height: 1.5rem;*/
        font-weight: 400;
        font-family: "Roboto", sans-serif;
        color: $atto-not-active;
        background-color: $atto-light-grey;
        border-radius: 100%;
        width: 100%;
        height: 100%;
        text-transform: uppercase;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }

    .name {
      align-items: center;

      h4 {
        font-weight: 400;
        font-size: 0.9375rem;
        line-height: 1.5rem;
      }

      i {
        display: none;
      }
    }
    .hour-total{
      max-width: 100%;
    }

    a{
      padding: 10px 0 10px 16px;
    }
  }
}
.logs-list{
  li{
    .hour-total{
      width: 100%;
      display: flex;
      justify-content: space-between;
      .hours{
        width: 85px;
        font-size: 0.875rem;
      }
    }
  }
}
.content-list{
  overflow-x: auto;
  width: 100%;
  .table-header{
    width: 100%;
    min-width: 1000px;
  }
  .table-content{
    width: 100%;
    display: flex;
    min-width: 1000px;
  }
}

@media (min-width: 2500px) {
  .member-list li .first-column {
    width: 400px;
  }
}
</style>
